import React, {createContext, useContext} from 'react'
import {type ColonistMembershipType} from '@colonist/types'

export interface UserStateContextProps {
    userId: string | undefined
    isLoggedIn: boolean
    totalCompletedGameCount: number
    hasMembership: boolean
    hasFoundersPack: boolean
    membershipType: ColonistMembershipType | undefined
}

const UserStateContext = createContext<UserStateContextProps | undefined>(undefined)

export const useUserStateContext = () => {
    const context = useContext(UserStateContext)
    if(!context) throw new Error('UserStateContext not found')
    return context
}

type UserStateContextProviderProps = React.PropsWithChildren<UserStateContextProps>

// @TODO: Move ClientUserState logic to this UserStateProvider as we refactor all the client to React
// TODO: UserStateContext shouldn't directly depend on ClientUserState.
//       Change to GameContextProvider (or a similar name) to decouple game from user state https://shottr.cc/s/2IMx/SCR-20260326-ktg.png
export const UserStateContextProvider = ({children, ...props}: UserStateContextProviderProps) => (
    <UserStateContext.Provider value={props}>
        {children}
    </UserStateContext.Provider>
)
